import { FavoriteMajorSurvey, FavoriteSurvey, UserPreferences } from '@common-types';

import { baseService } from '@services/base.service';

export const postSchoolFavoriteSurvey = async (data: FavoriteSurvey) => {
  return baseService.postAsync<UserPreferences, FavoriteSurvey>(`/user/favorites/colleges/surveys`, data);
};

export const postMajorFavoriteSurvey = async (data: FavoriteMajorSurvey) => {
  return baseService.postAsync<UserPreferences, FavoriteMajorSurvey>(`/user/favorites/majors/surveys`, data);
};
